import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import AppLayout from './components/AppLayout';
import LandingPage from './pages/LandingPage';
import GeneSearch from './pages/GeneSearch';
import DiseaseSearch from './pages/DiseaseSearch';
import PaperSearch from './pages/PaperSearch';
import SynaptopathyHistory from './pages/SynaptopathyHistory';
import SynapticERDiagram from './pages/SynapticERDiagram';
import About from './pages/About';
import APIDocMain from './APIDocumentation/APIDocMain';
import Publication from './pages/Publication';
import FAQPage from './pages/FAQpage';
import SynapticCompartmentsSection from './pages/SynapticCompartmentsSection';
import DiseaseClassificationsSection from './pages/DiseaseClassificationsSection';
import SynapticCompartmentsStandalone from './pages/SynapticCompartmentsStandalone';
import BrainRegionProteinDistribution from './pages/BrainRegionProteinDistribution';
import CookiesPolicy from './pages/CookiesPolicy';
import ApiCounterDashboard from './pages/ApiCounterDashboard';
import VisitTracker from './components/VisitTracker';
import GeneTable from './catalog/GeneTable';
import DiseaseTable from './catalog/DiseaseTable';
import PaperTable from './catalog/PaperTable';

function App() {
  return (
    
    <BrowserRouter>
      <VisitTracker />
      <Routes>
        
        <Route path="/" element={<AppLayout />}>

          <Route index element={<LandingPage />} />
          <Route path="gene-search" element={<GeneSearch />} />
          <Route path="disease-search" element={<DiseaseSearch />} />
          <Route path="paper-search" element={<PaperSearch />} />
          <Route path="synaptopathy-history" element={<SynaptopathyHistory />} />
          <Route path="about" element={<About />}/>
          <Route path="SynapticERDiagram" element={<SynapticERDiagram />} />
          <Route path="documentation" element={<APIDocMain />} />
          <Route path="publication" element={<Publication />} />

          <Route path="faq" element={<FAQPage />} />
          <Route path="synaptic-compartments" element={<SynapticCompartmentsSection />} />
          <Route path="synapse-localization" element={<SynapticCompartmentsStandalone />} />
          <Route path="disease-classifications" element={<DiseaseClassificationsSection />} />
          <Route path="brain-region-protein-distribution" element={<BrainRegionProteinDistribution />} />
          <Route path="api-counter-dashboard" element={<ApiCounterDashboard />} />
          <Route path="*" element={<div>Page Not Found</div>} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />

          <Route path="gene-table" element={<GeneTable />} />
          <Route path="disease-table" element={<DiseaseTable />} />
          <Route path="paper-table" element={<PaperTable />} />

          
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;